var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-menu',{staticClass:"plk_menu",attrs:{"menu":_vm.menu,"expanded":"true","collapsed":true,"hideToggle":""}})}
var staticRenderFns = []

export { render, staticRenderFns }